import { auth, db, fb } from '@/shared/firebase'
import store from '@/store'
import Vue from 'vue'

export default new Vue({
  store,
  methods: {
    addStock(params) {
      let { shelfId, spaceId, logFile, items, index, productId } = this._getStockBasics({
        ...params,
        action: 'addStock'
      })
      if (index !== -1) {
        const existingItem = items[index]
        if (params.expiryDate !== existingItem.expiryDate) {
          alert(`This item is alrady stocked in this shelf space and can't be merged due to different expiry dates.`)
        } else {
          const confirmed = confirm(
            `This item is alrady stocked in this shelf space. Do you want to merge it with the new arrival?`
          )
          if (confirmed) {
            this.editAmount({ ...params, newAmount: params.amount + existingItem.amount })
          }
        }
      } else {
        const { amount, expiryDate } = params
        const item = { productId, amount }
        if (expiryDate) {
          item.expiryDate = expiryDate
          logFile.expiryDate = expiryDate
        }
        items.push(item)
        logFile.amount = amount
        this._writeShelfUpdate(shelfId, { [`spaces.${spaceId}.items`]: items }, logFile)
      }
    },
    editAmount(params) {
      let { shelfId, spaceId, logFile, items, index } = this._getStockBasics({ ...params, action: 'editAmount' })
      const newAmount = params.newAmount
      if (newAmount === 0) {
        this.deleteStock(params)
      } else {
        const oldAmount = items[index].amount
        items[index].amount = parseFloat(newAmount)
        logFile = { ...logFile, oldAmount, newAmount }
        this._writeShelfUpdate(shelfId, { [`spaces.${spaceId}.items`]: items }, logFile)
      }
    },
    editExpiryDate(params) {
      let { shelfId, spaceId, logFile, items, index } = this._getStockBasics({ ...params, action: 'editExpiryDate' })
      let newExpiryDate = params.newExpiryDate
      if (newExpiryDate && newExpiryDate.length === 7) newExpiryDate = newExpiryDate + '-01'
      const oldExpiryDate = items[index].expiryDate || null
      items[index].expiryDate = newExpiryDate
      this._writeShelfUpdate(
        shelfId,
        { [`spaces.${spaceId}.items`]: items },
        { ...logFile, newExpiryDate, oldExpiryDate }
      )
    },
    deleteStock(params) {
      let { shelfId, spaceId, logFile, items, index } = this._getStockBasics({ ...params, action: 'deleteStock' })
      items.splice(index, 1)
      this._writeShelfUpdate(shelfId, { [`spaces.${spaceId}.items`]: items }, logFile)
    },
    _getStockBasics(params) {
      const { shelfId, spaceId, productId, origin } = params
      const logFile = this._getLogFile(params)
      if (origin) logFile.origin = origin
      const items = _.find(this.$store.state.shelves, { id: shelfId }).spaces[spaceId].items
      const index = _.findIndex(items, { productId })
      return { shelfId, spaceId, productId, logFile, items, index }
    },
    _getLogFile(params) {
      const { productId, action, shelfId, spaceId } = params
      const logFile = {
        productId,
        action,
        timestamp: {
          local: new Date(),
          server: fb.firestore.FieldValue.serverTimestamp()
        },
        user: {
          id: auth.currentUser.uid,
          displayName: auth.currentUser.displayName
        }
      }
      if (shelfId && spaceId) logFile.shelfSpaceId = `${shelfId}-${spaceId}`
      return logFile
    },
    _writeShelfUpdate(shelfId, shelfUpdate, logFile) {
      const batch = db.batch()
      batch.update(db.collection('/private/warehouse/shelves').doc(shelfId), shelfUpdate)
      const logDoc = db.collection('/private/warehouse/logs').doc()
      batch.set(logDoc, logFile)
      const today = new Date().toISOString().substr(0, 10)
      batch.set(
        db.doc(`private/logs/warehouseActivities/${today}`),
        {
          [auth.currentUser.uid]: fb.firestore.FieldValue.arrayUnion({
            action: logFile.action,
            timestamp: new Date()
          })
        },
        { merge: true }
      )
      batch.commit()
    }
  }
})
